import React from 'react';
import palette from '@ui/palette';
import Icon from '@ui/Icon';
import Typography from '@ui/Typography';

const CommentDescription = () => {
  return (
    <div
      style={{
        backgroundColor: palette.gray_800,
        borderRadius: 4,
        display: 'flex',
        gap: 10,
        padding: 10,
      }}
    >
      <Icon type="messageSquare02" />
      <Typography variant="pSm">
        Leave feedback, ask questions, or tag teammates with {'"@"'} to
        collaborate. Comments are visible to everyone with project access.
      </Typography>
    </div>
  );
};

export default CommentDescription;
